'use client';

import { captureException } from '@sentry/nextjs';
import ErrorPage from 'layout/src/components/ErrorPage';
import React, { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Keep the "[500] Template" message prefix (alerts/filters rely on it) but report the
    // real Error object so its message/stack survive — JSON.stringify(error) alone serializes
    // to `{}` because Error fields aren't enumerable. Wrapping preserves the original name and
    // stack, so Sentry groups by the underlying cause instead of one "[500] Template" bucket.
    const reportedError = new Error(
      `[500] Template. Hostname: ${window.location.hostname}. Message: ${error?.message ?? JSON.stringify(error)}`,
    );
    reportedError.name = error?.name ?? reportedError.name;
    reportedError.stack = error?.stack ?? reportedError.stack;

    captureException(reportedError, {
      tags: {
        errorType: '500',
        priority: 'high',
      },
      extra: {
        digest: error?.digest,
        hostname: window.location.hostname,
      },
    });
  }, [error]);

  return (
    <html lang="en-US">
      <body>
        <ErrorPage />
      </body>
    </html>
  );
}
